function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "jwm1a",
  d: "M488.75 516.92a1.75 1.75 0 1 0 0 3.5h16.94a1.75 1.75 0 1 0 0-3.5z"
}), React.createElement("path", {
  id: "jwm1b",
  d: "M488.75 511.78h7.056a1.75 1.75 0 1 0 0-3.5h-7.056a1.75 1.75 0 1 0 0 3.5z"
}), React.createElement("path", {
  id: "jwm1c",
  d: "M505.69 525.74h-16.94a1.75 1.75 0 1 0 0 3.5h16.94a1.75 1.75 0 1 0 0-3.5z"
}), React.createElement("path", {
  id: "jwm1d",
  d: "M516.006 511.488c-5.234 0-9.492-4.26-9.492-9.494 0-1.258.252-2.457.698-3.558l.004-.01c1.414-3.472 4.82-5.926 8.79-5.926 5.234 0 9.494 4.26 9.494 9.494s-4.26 9.494-9.494 9.494zM511.5 534.5h-23.706l-4.294-4.295V499.5h19.761a13.027 13.027 0 0 0-.247 2.494c0 5.579 3.54 10.332 8.486 12.171zm4.506-45.5c-5.001 0-9.345 2.845-11.516 7h-22.74a1.75 1.75 0 0 0-1.75 1.75v33.18c0 .466.184.91.513 1.237l5.32 5.32c.329.33.773.513 1.237.513h26.18a1.75 1.75 0 0 0 1.75-1.75v-21.315c.333.026.667.05 1.006.05 7.165 0 12.994-5.829 12.994-12.993 0-7.165-5.83-12.992-12.994-12.992z"
}), React.createElement("path", {
  id: "jwm1e",
  d: "M523.31 498.156a1.753 1.753 0 0 0-2.465-.238l-7.351 6.06-2.246-2.927a1.752 1.752 0 0 0-2.453-.326 1.75 1.75 0 0 0-.324 2.454l3.35 4.366a1.748 1.748 0 0 0 2.5.285l8.75-7.213a1.744 1.744 0 0 0 .238-2.46z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  transform: "translate(-480 -489)"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#jwm1a"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#jwm1b"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#jwm1c"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#jwm1d"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#jwm1e"
})))));

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document.1d9089e0.svg";
export { ForwardRef as ReactComponent };